export default __webpack_public_path__ + "static/media/crypto.8c6fa44d.png";